import { useEffect, useMemo } from "react";
import { MiButton, MiDetailPageHeader, MiTab } from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  ENTITY_NAMES,
  ICONS_WEB,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { InspectionTemplateAssignmentTemplateModal } from "./InspectionTemplateAssignmentTemplateModal";
import { AssignmentTemplatesTab, Details } from "./tabs";
import { useInspectionTemplateViewModel } from "./useInspectionTemplateViewModel";

const ROUTE_NAMES = {
  DETAILS: "details",
  INPUT_OPTIONS: "input-options",
  TEMPLATES: "assignment-templates",
  HOLD_REASONS: "hold-reasons",
};

const TAB_NAMES = {
  DETAILS: "Details",
  INPUT_OPTIONS: "Input Options",
  TEMPLATES: "Assignment Templates",
  HOLD_REASONS: "Hold Reasons",
};

const TAB_LIST = [
  {
    name: TAB_NAMES.DETAILS,
    value: ROUTE_NAMES.DETAILS,
    label: TAB_NAMES.DETAILS,
  },
  // TODO: If Assignment Templates tab is neded. We Can enable it here
  // {
  //   name: TAB_NAMES.TEMPLATES,
  //   value: ROUTE_NAMES.TEMPLATES,
  //   label: TAB_NAMES.TEMPLATES,
  // },
];

export function InspectionTemplate() {
  const router = useRouter();
  const { id: inspectionTemplateId, activeTab } = router.params;

  const {
    inspectionTemplate,
    loading,
    isModalOpen,
    getAllAssignmentTemplates,
    handleAddAssignmentTemplate,
    closeModal,
    openModal,
    getInspectionTemplateDetails,
    onDetailsUpdate,
    getTrades,
    trades,
  } = useInspectionTemplateViewModel({ inspectionTemplateId });

  useEffect(() => {
    getInspectionTemplateDetails();
    getTrades();
  }, [inspectionTemplateId]);

  const actionComponent = useMemo(() => {
    switch (activeTab) {
      case ROUTE_NAMES.TEMPLATES:
        return (
          <MiButton
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            variant={BUTTON_VARIANTS.CONTAINED}
            onClick={openModal}
            data-testid="add-btn"
            title="Add Assignment Template"
          />
        );
      default:
        return null;
    }
  }, [activeTab]);

  const handleTabChange = (tab) => {
    router.navigate(
      `/settings/order-management/inspection-types/${inspectionTemplateId}/${tab}`
    );
  };

  const customOnBack = () => {
    router.navigate(`/settings/order-management/inspection-types`);
  };
  return (
    <>
      <MiDetailPageHeader
        loading={loading}
        title={`${ENTITY_NAMES.INSPECTION_TEMPLATE}: ${
          inspectionTemplate?.name || ""
        }`}
        titleIcon={mdi[ICONS_WEB.CHEVRON_LEFT]}
        actionComponent={actionComponent}
        customOnBack={customOnBack}
      />
      <MiTab
        tabs={TAB_LIST}
        currentTab={activeTab}
        onTabChange={handleTabChange}
      />
      {activeTab === ROUTE_NAMES.DETAILS && (
        <Details
          inspectionTemplate={inspectionTemplate}
          trades={trades}
          onUpdate={onDetailsUpdate}
        />
      )}
      {activeTab === ROUTE_NAMES.TEMPLATES && (
        <AssignmentTemplatesTab
          inspectionTemplate={inspectionTemplate}
          refresh={getInspectionTemplateDetails}
        />
      )}
      <InspectionTemplateAssignmentTemplateModal
        open={isModalOpen}
        getAllAssignmentTemplates={getAllAssignmentTemplates}
        title="Add Assignment Template"
        buttonTitle="Submit"
        onClose={closeModal}
        onSubmit={handleAddAssignmentTemplate}
      />
    </>
  );
}
